<template>
<header class="header">
  <div class="logo header__logo">
    <span class="header__title">
      Aba.kg
    </span>
  </div>
</header>
</template>

<script>
export default {
  name: 'sHeader'
}
</script>

<style scoped>
    .header{
      margin:50px 0 0
    }
    .logo{
      background:url("../assets/images/ic-logo.png") no-repeat;
      background-size: contain;
      height:72px;
    }
  .header__title{
    line-height: 5;
    padding-left: 105px;
    font-family: SegoeUI;
    font-size: 24px;
    font-weight: 300;
    color: #ffffff;
  }
    @media (min-width: 995px) and (min-height: 851px){
      .header{
        position:absolute;
        top:50px;
        margin:0
      }
    }
</style>




// WEBPACK FOOTER //
// sHeader.vue?7898eb58